import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getThemeTokens } from '../tokens';

export const styledMuiInputBase = (
  theme: Theme,
): BackstageOverrides['MuiInputBase'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      color: tokens.textPrimary,
      fontSize: theme.typography.body1.fontSize,
    },
    input: {
      '::placeholder': {
        color: tokens.textMuted,
        opacity: 1,
      },
    },
  };
};
